<div
   *ngIf="hospitalInfo"
   class="hospital-column-container">
   <span class="hospitalIcon">
      <i class="icon fas fa-hospital"></i>
   </span>
   <div class="hospital-column-row">
      <span class="itemLabel">Hospital Name</span>
      <br />
      <span class="itemValue">{{ hospitalInfo.friendlyName }}</span>
   </div>
   <div class="hospital-column-row">
      <span class="itemLabel">Hospital Manager</span>
      <br />
      <span class="itemValue">{{ hospitalInfo.hmDisplayName }}</span>
   </div>
   <div class="hospital-column-row">
      <span class="itemLabel">Chief of Staff</span>
      <br />
      <span class="itemValue">{{ hospitalInfo.cosDisplayName }}</span>
   </div>
   <div class="hospital-column-row last">
      <span class="itemLabel">Phone</span>
      <br />
      <span class="itemValue">{{ hospitalInfo.practicePhone | phone:'US' }}</span>
   </div>
   <div
      *ngIf="hospitalInfo.logoUrl"
      class="hospital-column-logo">
      <img [src]="'https://vetcor.skyworld.com' + hospitalInfo.logoUrl" />
   </div>
</div>
